import { useReducer } from "react";

export type QuestionsFilterProps = {
  processed: "all" | "processed" | "unprocessed";
  marketplace_auth_id: number[];
  search: string;
  article: string;
  sorting: "asked_at_desc" | "asked_at_asc";
  page: number;
};

const defaultState: QuestionsFilterProps = {
  processed: "unprocessed",
  marketplace_auth_id: [],
  search: "",
  article: "",
  sorting: "asked_at_desc",
  page: 1,
};

function reducer(
  state: QuestionsFilterProps,
  action:
    | { type: "update"; payload: Partial<QuestionsFilterProps> }
    | { type: "set"; payload: QuestionsFilterProps },
) {
  switch (action.type) {
    case "set":
      return action.payload;
    case "update":
      return { ...state, page: 1, ...action.payload };
    default:
      throw new Error();
  }
}

export const useFilterState = () => {
  const [state, dispatch] = useReducer(reducer, defaultState);
  const set = (payload: QuestionsFilterProps) =>
    dispatch({ type: "set", payload });
  const update = (payload: Partial<QuestionsFilterProps>) =>
    dispatch({ type: "update", payload });
  return { state, set, update };
};

export type FilterState = ReturnType<typeof useFilterState>;
